import { isMobileDevice } from './tools';


const getWhatsappUrl = ({ phone, message }) => {
    let whatsAppUrl = `https://wa.me/${phone}?text=${message}`;
    if (isMobileDevice()) {
        whatsAppUrl = `whatsapp://send?text=${message}&phone=+${phone}&abid=+${phone}`;
    }
    return whatsAppUrl;
};


export default getWhatsappUrl;
